module.exports = "/fonts/fa-regular-400.woff2?c20b5b7362d8d7bb7eddf94344ace33e";